import { render, staticRenderFns } from "./AppImageTextBlock.vue?vue&type=template&id=2ce0b91a&scoped=true"
import script from "./AppImageTextBlock.vue?vue&type=script&lang=js"
export * from "./AppImageTextBlock.vue?vue&type=script&lang=js"
import style0 from "./AppImageTextBlock.vue?vue&type=style&index=0&id=2ce0b91a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce0b91a",
  null
  
)

export default component.exports